import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Hero from '../components/home/Hero';
import FeatureSplit from '../components/home/FeatureSplit';
import SpiritSection from '../components/home/SpiritSection';
import QuoteBand from '../components/home/QuoteBand';
import UpcomingReleases from '../components/home/UpcomingReleases';
import ContactSection from '../components/home/ContactSection';
import { features } from '../mock';

export default function Home() {
  return (
    <div className="bg-[#f4f1eb] text-[#2b2a27]">
      <Navbar />
      <main>
        <Hero />

        <FeatureSplit
          id={features[0].id}
          label={features[0].label}
          title={features[0].title}
          description={features[0].description}
          image={features[0].image}
          coord={features[0].coord}
        />

        <FeatureSplit
          id={features[1].id}
          label={features[1].label}
          title={features[1].title}
          description={features[1].description}
          image={features[1].image}
          coord={features[1].coord}
          reverse
        />

        <UpcomingReleases />

        <QuoteBand />

        <FeatureSplit
          id={features[2].id}
          label={features[2].label}
          title={features[2].title}
          description={features[2].description}
          image={features[2].image}
          coord={features[2].coord}
        />

        <FeatureSplit
          id={features[3].id}
          label={features[3].label}
          title={features[3].title}
          description={features[3].description}
          image={features[3].image}
          coord={features[3].coord}
          reverse
        />

        <SpiritSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
